import ApocalypseEventTarget from "rydori-apocalypse-commonjs/core/ApocalypseEventTarget";
import APIHelper from "@giscon/utils.api-helper-esri";
import layerStore from "@giscon/utils.layer-store";

import LayerManager from "./LayerManager";

export default class SelectionManager extends ApocalypseEventTarget {
  static get SELECTIONMODE_SINGLE() {
    return 1;
  }

  static get SELECTIONMODE_MULTIPLE() {
    return 2;
  }

  static get SELECTIONMODE_SAMETYPE() {
    return 3;
  }

  static get SELECTIONMODE_SAMELAYER() {
    return 4;
  }

  static get SELECTIONMODE_CHOOSE() {
    return 5;
  }

  static get SELECTIONTOGGLEMODE_TOGGLE() {
    return 0;
  }

  static get SELECTIONTOGGLEMODE_ADD() {
    return 1;
  }

  static get availableEvents() {
    // TODO: neuere events müssen hier angegeben werden, sonst können keine events dafür registriert werden
    return [
      "selection-start",
      "selection-end",
      "selection-mode-change",
      // 'choose-selection',
      "trigger-show-selection-options",
      "selection-enable-change",
    ];
  }

  constructor({
    layerManager,
    view,
    selectionMode,
    selectionToggleMode,
    resetSelectionOnBasemapClick,
    nls,
  }) {
    /**
     * TODO: Wenn man mehrere Änderungen an Grafiken machen möchte bevor diese gepusht(applyEdit) werden, dann müssen wenn auch cut und mege unterstützt werden die bearbeiteten Features auch vorgehalten werden neben den Selektierten!!
     * IDEE: Selektieren mit gezeichneter Geometrie (freihand oder viereck/extent) und dann entweder alle innerhalb oder alle grafiken die davon berührt werden selektieren
     */
    super();
    this.nls = nls;
    this.onlyFirstHit = true; // TODO: evtl konfigurierbar und wenn dann muss eventuell eine Funktion gegeben werden welche die neu selektion filtern kann
    this.layerManager = layerManager;
    // this.layerManager.setSelectionManager(this);
    this.view = view;
    this.selection = [];
    this.highlightSelect = null;

    // set selection mode from config or default
    this.selectionMode =
      selectionMode !== undefined
        ? selectionMode
        : SelectionManager.SELECTIONMODE_SAMELAYER;
    this.selectionToggleMode =
      selectionToggleMode !== undefined
        ? selectionToggleMode
        : SelectionManager.SELECTIONTOGGLEMODE_TOGGLE;
    this.resetSelectionOnBasemapClick = resetSelectionOnBasemapClick !== false; // TODO
    setTimeout(() => {
      // just for view nessesary
      this.fireEvent("selection-mode-change", {
        mode: this.selectionMode,
        toggleMode: this.selectionToggleMode,
      });
    }, 500);
    this.activateSelection();
  }

  addLoadingPromise(promise) {
    return this.layerManager.addLoadingPromise(promise);
  }

  activateSelection() {
    this.registerClickHandler();
    this.fireEvent("selection-enable-change", true);
  }

  isSelectionActive() {
    return !!this.clicklistener;
  }

  deactivateSelection() {
    this.removeClickHandler();
    this.fireEvent("selection-enable-change", false);
  }

  restoreSelection() {
    const currentAction = this.layerManager.getCurrentAction();

    if (
      (!currentAction && !this.layerManager.hasChanges()) ||
      (currentAction && currentAction.enableSelection) // TODO: Fall Arbeitsauftaege ...
    ) {
      this.activateSelection();
    } else {
      this.deactivateSelection();
    }
  }

  set selectionMode(mode) {
    // eslint-disable-next-line no-underscore-dangle
    this._selectionMode = mode;
    if (mode === SelectionManager.SELECTIONMODE_SINGLE) {
      if (this.selection.length) {
        // select only first graphic in previous selection
        this.selection = [this.selection[0]];
        this.layerManager.redraw();
      }
    } else {
      const selection = this.selection.concat([]);
      // this.selection = [];
      this.resetSelection(true);
      this.select(selection, false, true);
      this.layerManager.redraw();
    }
    this.fireEvent("selection-mode-change", { mode });
  }

  get selectionMode() {
    // eslint-disable-next-line no-underscore-dangle
    return this._selectionMode;
  }

  set selectionToggleMode(mode) {
    // eslint-disable-next-line no-underscore-dangle
    this._selectionToggleMode = mode;
    this.fireEvent("selection-mode-change", { toggleMode: mode });
  }

  get selectionToggleMode() {
    // eslint-disable-next-line no-underscore-dangle
    return this._selectionToggleMode;
  }

  selectByExtent(layer, extent, callback) {
    // TODO: Layer has to be selected!!
    const start = new Date();
    const promise = APIHelper.getGraphicsTouchedByExtent(layer, extent, true);
    this.addLoadingPromise(promise);
    promise
      .then((graphics) => {
        const end = new Date();
        this.select(graphics, true);
        const end2 = new Date();
        console.error(
          `Needed ${end - start} to calculate hits\nNeeded ${end2 - end
          } to select those`
        );
        // eslint-disable-next-line no-unused-expressions
        callback && callback();
      })
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error("an error occurred in selectByExtent", e);
        // eslint-disable-next-line no-unused-expressions
        callback && callback();
      });
  }

  setSelectionByAction(action, undo) {
    this.resetSelection(true);
    if (undo || !action.state.newIds) {
      this.select(
        action.state.ids.map((id) => {
          return this.layerManager.getGraphicByInternalId(id);
        })
      );
    } else {
      this.select(
        action.state.newIds.map((id) => {
          return this.layerManager.getGraphicByInternalId(id);
        })
      );
    }
  }

  removeClickHandler() {
    // console.error('remove layermanager listener');
    if (this.clicklistener) {
      this.layerManager.removeEventListener(
        "layer-clicked",
        this.clicklistener
      );
      this.clicklistener = null;
    }

    this.fireEvent("trigger-show-selection-options", {});
  }

  internalSelection(feature, create) {
    if (create) {
      this.select(feature, true);
    } else if (!this.layerManager.isDeleted(feature)) {
      /* if (this.selectionMode === SelectionManager.SELECTIONMODE_CHOOSE) {
        this.fireEvent('choose-selection', {
          hits,
          select: g => {
            this.select(g);
          },
          highlight: g => {
            this.controller.layerManager.highlight(g);
          },
        });
      }
      // you cannot select deleted graphics (use the undo button)
      else */ if (
        this.selectionToggleMode === SelectionManager.SELECTIONTOGGLEMODE_TOGGLE
      ) {
        if (this.isSelected(feature)) {
          this.deselect(feature);
        } else {
          this.select(feature, false);
        }
      } else {
        this.select(feature, false);
      }
    }
  }

  zoomToSelection() {
    this.layerManager.zoomToGraphics(this.selection.concat([]));
  }

  registerClickHandler() {
    const handleSelection = (graphic) => {
      const features = this.layerManager.getEditGraphics(graphic, false); // TODO:check ob true ok!!

      if (features.length === 0) {
        this.internalSelection(graphic, true);
      } else {
        for (let j = 0; j < features.length; j++) {
          const feature = features[j];
          // get fresh attributes on editgraphic
          APIHelper.setAttributes(feature, APIHelper.getAttributes(graphic));
          // feature.attributes = graphic.attributes;
          this.internalSelection(feature, false);
        }
      }
    };

    this.removeClickHandler(); // when no click listener defined => nothing will be done

    this.clicklistener = (event) => {
      const { hits } = event.data;
      // TODO: check if hitsEditLayer has to be a Substractor for the other hits : hit on graphics layer => ignore on other layers (getEditGraphics(graphic, false) === null/[])
      if (hits.length === 0 && this.resetSelectionOnBasemapClick) {
        this.resetSelection();
        this.fireEvent("trigger-show-selection-options", {});
      } else if (hits.length === 1) {
        const promise = new Promise((resolve /* , reject */) => {
          this.fireEvent("selection-start", {});
          APIHelper.getNonGeneralized(hits)
            .then((selectedNonGeneralized) => {
              handleSelection(selectedNonGeneralized.flat()[0]);
              resolve();
            })
            .catch((e) => {
              this.fireEvent("selection-start", { error: true });
              console.error("Selectionerror: ", e);
              resolve(); // promise is only for BI purposes
            });
        });
        this.addLoadingPromise(promise);
        this.fireEvent("trigger-show-selection-options", {});
      } else {
        const forSelection = [];
        const forDeselection = [];
        hits.forEach((hit) => {
          if (this.isSelected(hit)) {
            forDeselection.push(hit);
          } else {
            forSelection.push(hit);
          }
        });

        this.fireEvent("trigger-show-selection-options", {
          graphics: hits,
          forSelection,
          forDeselection,
          title: this.nls.chooseSelectionClick,
          allowAbort: true,
          callback: (selection) => {
            // const hasClickListener = !!this.clicklistener;
            // if (hasClickListener) {
            //   this.removeClickHandler();
            // }
            if (selection) {
              const graphics = Array.isArray(selection)
                ? selection
                : [selection];
              const promise = new Promise((resolve /* , reject */) => {
                APIHelper.getNonGeneralized(graphics)
                  .then((selectedNonGeneralized) => {
                    selectedNonGeneralized.flat().forEach((graphic) => {
                      handleSelection(graphic);
                    });
                    resolve();
                  })
                  .catch(() => {
                    resolve(); // promise is only for BI purposes
                  });
              });
              // this.addLoadingPromise(promise);
            } else {
              // this only happens on abort
              // TODO: nothing // or reset?
            }
          },
        });
      }
    };
    this.layerManager.addEventListener("layer-clicked", this.clicklistener);
  }

  openGraphicSelector(options) {
    this.fireEvent("trigger-show-selection-options", options || {});
  }

  isSelected(feature) {
    for (let i = 0; i < this.selection.length; i++) {
      if (this.selection[i] === feature) {
        // eventuell diesen Vergleich in Funktion auslagern, damit es möglich ist eine veränderte Graphic auf dem EditLayer mit der auf dem ursprünglichen Layer zu vergleichen, dabei müssen wahrscheinlich nur layer und pbjhectid vorgehalten und vberglichen werden
        return true;
      }
    }
    return false;
  }

  deselect(feature) {
    if (Array.isArray(feature)) {
      for (let i = feature.length - 1; i >= 0; i--) {
        // TODO: maybe a no fire event?
        this.deselect(feature[i]);
      }
      return undefined;
    }
    // TODO: graphiken die dem Editor Layer sind und aber nicht verändert wurden von diesem entfernen? (damit nur nötiges auf dem Layer ist)
    let deleted = false;
    const graphics = this.layerManager.getEditGraphics(feature, false);
    if (graphics && graphics.length) {
      for (let j = 0; j < graphics.length; j++) {
        const graphic = graphics[j];
        for (let i = 0; i < this.selection.length; i++) {
          if (graphic === this.selection[i]) {
            this.selection.splice(i, 1); // remove element i from array (returns array of elemts deleted)
            deleted = true;
            break;
          }
        }
      }
      if (deleted) {
        this.layerManager.redraw();
        this.fireEvent("selection-end", {
          selectedFeatures: this.selection,
          feature,
          deselected: true,
        });
      }
      return deleted;
    }
    return false;
  }

  /*
  clear() {
    this.deselect(this.selection.concat([])); // important to use an copy => otherwise weird behavior possible
  }
*/

  isInSelection(feature) {
    if (this.selection.length === 0) {
      return false;
    }
    if (
      APIHelper.getLayer(feature) !==
      this.layerManager.getOriginLayer(this.selection[0]).layer
    ) {
      return false;
    }

    const oidField = APIHelper.getObjectIdField(feature.layer);
    const { attributes } = feature;
    const keys = Object.keys(attributes);
    const hasNoObjectId =
      !(oidField in attributes) &&
      attributes[oidField] !== undefined &&
      attributes[oidField] !== null;

    for (let i = 0; i < this.selection.length; i++) {
      const tattributes = APIHelper.getAttributes(this.selection[i]);
      if (hasNoObjectId) {
        // oder in feature testen?
        const selectionkeys = Object.keys(tattributes);
        let found = true;
        for (let j = 0; j < keys.length; j++) {
          if (attributes[keys[j]] !== tattributes[keys[j]]) {
            found = false;
          }
        }
        if (!keys.length && selectionkeys.length) {
          found = false;
        }
        if (found) return true;
      } else if (attributes[oidField] === tattributes[oidField]) {
        return true;
      }
    }
    return false;
  }

  select(feature, create, noredraw, nofire) {
    this.fireEvent("selection-start", {});
    // TODO: mapping zwischen features auf featurelayer und graphicsLayer (am besten über layer referenz und id)
    // TODO: graphiken die noch nicht auf dem Editor Layer sind und selektiert werden auf diesem hinzufügen
    if (Array.isArray(feature)) {
      // const features = feature.filter((f) => this.selection.indexOf(f) === -1);
      const features = feature.filter((f) => !this.isInSelection(f));
      for (let i = 0; i < features.length; i++) {
        // TODO: maybe a no fire event?
        this.select(features[i], create, true, true);
      }
      if (!noredraw) this.layerManager.redraw(); // draw selected features;
      this.fireEvent("selection-end", {
        selectedFeatures: this.selection,
        feature: features.length && features[features.length - 1],
      });
    } else if (!this.isInSelection(feature)) {
      // because aof a bug when you click on a raw graphic that is splitted
      // handle selection Mode
      const graphics = create
        ? this.layerManager.getEditGraphics(feature, true)
        : [feature];
      if (graphics && graphics.length) {
        for (let i = 0; i < graphics.length; i++) {
          const graphic = graphics[i];
          if (this.selectionMode === SelectionManager.SELECTIONMODE_SINGLE) {
            this.selection = [];
          } else if (
            this.selectionMode === SelectionManager.SELECTIONMODE_SAMELAYER
          ) {
            if (
              this.selection.length >= 1 &&
              (
                (
                  !create &&
                  this.layerManager.getOriginLayer(feature).layer !==
                  this.layerManager.getOriginLayer(this.selection[0])
                ).layer ||
                (create &&
                  APIHelper.getLayer(feature) !==
                  this.layerManager.getOriginLayer(this.selection[0]))
              ).layer
            )
              this.selection = [];
          } else if (
            this.selectionMode === SelectionManager.SELECTIONMODE_SAMETYPE
          ) {
            if (
              this.selection.length >= 1 &&
              LayerManager.getGeometryType(graphic) !==
              LayerManager.getGeometryType(this.selection[0])
            )
              this.selection = [];
          }
          // this.fireEvent("selection-end", {h: 1, f: feature});
          if (
            !APIHelper.isGraphicOnLayer(
              graphic,
              this.layerManager.graphicsLayer
            )
          ) {
            // Hack because of Bug, when you save and click on the saved feature without first clearing the state => to check if this is the right way to do it
            APIHelper.addGraphicToLayer(
              graphic,
              this.layerManager.graphicsLayer
            );
          }
          this.selection.push(graphic);
        }
        if (!noredraw) this.layerManager.redraw(); // draw selected features;
        if (!nofire) {
          this.fireEvent("selection-end", {
            selectedFeatures: this.selection,
            feature,
          });
        }
      }
    }
  }

  resetSelection(noredraw) {
    const oldSelection = this.selection;
    this.selection = [];
    if (oldSelection.length) {
      this.fireEvent("selection-end", {
        selectedFeatures: this.selection,
      });
    }
    this.fireEvent("trigger-show-selection-options", {});
    if (!noredraw) this.layerManager.redraw();
  }

  reset() {
    this.resetSelection(false);
    /*
    this.selection = [];
    this.fireEvent('selection-end', {
      selectedFeatures: this.selection,
    });
    */
  }

  getSelection() {
    return this.selection.concat([]); // copy of the array just to be sure
  }

  addToSelectionAttributive({ layer, name }, value, withEditRule) {
    const layerObj = layerStore.getLayer(layer);
    const editRule = layerObj && layerObj.editRule;
    let geo;
    if (withEditRule && editRule && editRule.ruleGeometry) {
      geo = editRule.ruleGeometry;
    }
    if (layerObj) {
      this.fireEvent("selection-start", {});
      this.addLoadingPromise(
        new Promise((resolve, reject) => {
          APIHelper.queryFeaturesOnLayer(
            name,
            value,
            layerObj.layer,
            this.layerManager.map,
            geo
          )
            .then((features) => {
              this.select(features, true);
              resolve();
            })
            .catch((e) => {
              // eslint-disable-next-line no-console
              console.error("some error occured with a query", e);
              this.fireEvent("selection-start", { error: true });
              reject();
            });
        })
      );
    } else {
      this.fireEvent("selection-start", {});
      this.addLoadingPromise(
        new Promise((resolve, reject) => {
          APIHelper.getNonGeneralizedOneLayer(
            this.layerManager.getGraphicsByAttributeAndValue(layer, name, value)
          )
            .then((features) => {
              this.select(features.flat(), true);
              resolve();
            })
            .catch((e) => {
              // eslint-disable-next-line no-console
              this.fireEvent("selection-start", { error: true });
              console.error("some error occured with a query", e);
              reject();
            });
        })
      );
    }
  }

  setSelectionAttributive(
    { layer, name },
    value,
    callback,
    zoom,
    withEditRule
  ) {
    const layerObj = layerStore.getLayer(layer);
    const editRule = layerObj && layerObj.editRule;
    let geo;
    if (withEditRule && editRule && editRule.ruleGeometry) {
      geo = editRule.ruleGeometry;
    }
    if (layerObj) {
      this.addLoadingPromise(
        new Promise((resolve, reject) => {
          this.resetSelection();
          this.fireEvent("selection-start", {});
          APIHelper.queryFeaturesOnLayer(
            name,
            value,
            layerObj.layer,
            this.layerManager.map,
            geo
          )
            .then((features) => {
              this.select(features, true);
              if (callback) callback();
              if (zoom) {
                this.zoomToSelection();
              }
              resolve();
            })
            .catch((e) => {
              // eslint-disable-next-line no-console
              console.error("some error occured with a query", e);
              this.fireEvent("selection-start", { error: true });
              if (callback) callback();
              reject();
            });
        })
      );
    }
  }

  removeFromSelectionAttributive({ layer, name }, value) {
    this.addLoadingPromise(
      new Promise((resolve /* , reject */) => {
        this.deselect(
          // TODO: schauen, dass hier auch aus der selektion entfernt wird was auf dem layer selbst keine entsprechung hat
          this.layerManager.getGraphicsByAttributeAndValueArray(
            this.selection,
            name,
            value
          )
        );
        resolve();
      })
    );
  }
}
